<template>
    <el-dialog :visible.sync="visible" width="1200px" top="5vh" :close-on-click-modal="false" :before-close="handleClose" custom-class="radius-dialog">
        <div slot="title" class="dialog-title">
            <h3>开票详情</h3><span>更新日期：{{ latestTime }}</span>
        </div>
        <div v-loading="loadAll">
            <div class="filters-container">
                <div class="filter-line">
                    <div class="title-name">学校名称：</div>
                    <div class="filter-ipt">
                        <el-input prefix-icon="el-icon-search" v-model="filters.schoolName" placeholder="搜索学校名称" class="no-border" @change="fetchData" clearable />
                    </div>
                </div>
                <CheckedSelect v-model="filters.saleUserId" :options="mySaleUserOptions" label="销售人员" @change="fetchData" />
                <CheckedSelect v-model="filters.productId" :options="[{id:'',name:'全部'}, ...productList]" label="产品分类" @change="fetchData" />
                <div class="filter-line">
                    <div class="title-name">{{ filters.statisticsType == 0 ? '开票' : '到账' }}日期：</div>
                    <div class="filter-select">
                        <el-date-picker v-model="filters.signDate" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
                            value-format="yyyy-MM-dd" @change="fetchData" />
                    </div>
                </div>
                <div style="display: flex; margin-bottom: 8px;">
                    <CheckedSelect v-model="filters.statisticsType" :options="[{id:0,name:'按开票日期统计'},{id:1,name:'按到账日期统计'}]" label="统计方式" @change="statisticsTypeChange"
                        style="margin-right: 100px; margin-bottom: 0;" />
                    <CheckedSelect v-if="filters.statisticsType === 0" v-model="filters.receiveFlag" :options="[{id:'',name:'全部'},{id:1,name:'已到账'},{id:0,name:'未到账'}]"
                        label="是否到账" @change="fetchData" />
                </div>
                <div class="red-text" v-if="totalCount">
                    <i class="el-icon-warning-outline"></i>
                    <span class="text" v-html="total_describe"></span>
                </div>
                <div class="export-box">
                    <el-button type="primary" icon="el-icon-download" :loading="loadExport" @click="exportData">导出列表</el-button>
                </div>
            </div>
            <el-table :data="tableData.slice((pageNum - 1) * pageSize, pageNum * pageSize)" row-key="contractId" @sort-change="tableSortChange"
                :header-cell-style="{'background-color': '#F2F3F5', 'color': '#333' }">
                <el-table-column label="序号" width="60" align="center">
                    <template slot-scope="{$index}">{{ $index + 1 + (pageNum - 1) * pageSize }}</template>
                </el-table-column>
                <el-table-column prop="schoolName" label="学校" min-width="150" align="left"></el-table-column>
                <el-table-column prop="productName" label="产品" min-width="120" align="left" show-overflow-tooltip></el-table-column>
                <el-table-column prop="saleUserName" label="销售" min-width="100" align="left"></el-table-column>
                <el-table-column prop="invoiceDate" label="开票日期" min-width="120" align="left" sortable="custom"></el-table-column>
                <el-table-column prop="payDate" label="到账日期" min-width="120" align="left"></el-table-column>
                <el-table-column prop="price" label="金额(元)" width="120" align="left">
                    <template slot-scope="{row}">￥{{ row.price }}</template>
                </el-table-column>
                <el-table-column prop="remark" label="备注" min-width="250" align="left" show-overflow-tooltip></el-table-column>
            </el-table>
            <pagination v-show="totalCount" :total="totalCount" :page.sync="pageNum" :limit.sync="pageSize" :pageSizes="[10, 20, 40, 50]" style="margin-top: 20px;" />
        </div>
    </el-dialog>
</template>

<script>
import { mapState } from 'vuex';
import { findContractPayList, downloadContractPayList } from '@/api/statistics/index.js';

export default {
    name: 'invoiceDetail',
    props: {
        visible: Boolean, // 弹窗显示/隐藏
        params: Object, // 总览统计的参数
        latestTime: String, // 数据最新更新时间
    },
    watch: {
        visible(val) {
            if (val) {
                this.pageNum = 1;
                this.pageSize = 10;
                this.filters.schoolName = ''
                this.filters.saleUserId = this.params.saleUserId;
                this.filters.productId = this.params.productId;
                this.filters.signDate = [];
                this.filters.statisticsType = this.params.statisticsType;
                this.filters.receiveFlag = this.params.receiveFlag
                // 处理日期格式为'yyyy-MM-dd'
                let { year, month, signDate } = this.params;
                if (signDate) {
                    this.filters.signDate = signDate;
                } else if (year && !month) {
                    // 有年没有月，开始为1月1日，结束为12月31日
                    this.filters.signDate[0] = `${year}-01-01`;
                    this.filters.signDate[1] = `${year}-12-31`;
                } else if (year && month) {
                    // 有年有月，开始为月的1日，结束为月的最后一天
                    this.filters.signDate[0] = this.$utils.formatDate(new Date(year, month - 1, 1), 'yyyy-MM-dd');
                    this.filters.signDate[1] = this.$utils.formatDate(new Date(year, month, 0), 'yyyy-MM-dd');
                }

                this.fetchData();
            }
        }
    },
    data() {
        return {
            loadAll: true,
            filters: {
                schoolName: '',
                saleUserId: '',
                productId: '',
                signDate: [],
                statisticsType: 0,
                receiveFlag: ''
            },
            // 分页
            pageNum: 1,
            pageSize: 10,
            // 表格数据
            tableData: [],
            totalCount: 0, // 合同总数量
            // 文字说明
            total_describe: '',
            // 导出
            loadExport: false,
        }
    },
    computed: {
        ...mapState(["productList", "mySaleUserOptions"]),
    },
    methods: {
        // 获取数据
        fetchData() {
            this.loadAll = true;
            let params = {
                ...this.filters,
                startDate: this.filters.signDate ? this.filters.signDate[0] : '',
                endDate: this.filters.signDate ? this.filters.signDate[1] : ''
            }
            delete params.signDate
            findContractPayList(params).then(res => {
                let { contractPayModelList, payPrice, notPayPrice, invoicePrice } = res.data;
                this.totalCount = contractPayModelList.length || 0;
                this.tableData = contractPayModelList?.map((item, index) => {
                    return {
                        ...item,
                        sort: index
                    }
                }) ?? [];
                if (this.filters.statisticsType == 0) {
                    this.total_describe = `按开票统计共开出发票<b>${contractPayModelList.length}</b>次，总金额<b>${invoicePrice}</b>万元，已到账金额<b>${payPrice}</b>万元，未到账金额<b>${notPayPrice}</b>万元。`
                } else if (this.filters.statisticsType == 1) {
                    this.total_describe = `按到账统计共收到汇款<b>${contractPayModelList.length}</b>次，总金额<b>${payPrice}</b>万元`;
                    let price_distribution = '';
                    if (res.data.yearList && res.data.yearList.length) {
                        price_distribution = '，其中';
                        price_distribution += res.data.yearList.map(x => {
                            return `<b>${x.year}</b>年开票<b>${x.value}</b>万元`
                        }).join('，')
                    }
                    this.total_describe += price_distribution + '。';
                }
                this.loadAll = false;
            }).catch(err => {
                if (err.status === 888) return;
                this.totalCount = 0;
                this.tableData = [];
                this.total_describe = '';
                this.loadAll = false;
                this.$MessageBox.MessageWarning(err.data.msg);
            })
        },
        // 表格排序
        tableSortChange({ prop, order }) {
            if (order == "ascending") {
                // 升序
                if (prop === 'invoiceDate') {
                    this.tableData.sort((a, b) => new Date(a[prop]) - new Date(b[prop]));
                } else {
                    this.tableData.sort((a, b) => a[prop] - b[prop]);
                }
            } else if (order == "descending") {
                // 降序
                if (prop === 'invoiceDate') {
                    this.tableData.sort((a, b) => new Date(b[prop]) - new Date(a[prop]));
                } else {
                    this.tableData.sort((a, b) => b[prop] - a[prop]);
                }
            } else {
                this.tableData.sort((a, b) => a.sort - b.sort);
            }
            this.pageNum = 1;
        },
        // 统计方式 选中“按到账日期统计”时，不显示是否到账，清空选项
        statisticsTypeChange() {
            if (this.filters.statisticsType === 1) {
                this.filters.receiveFlag = '';
            }
            this.fetchData()
        },
        // 关闭弹窗
        handleClose() {
            this.$emit("update:visible", false);
        },
        // 点击导出
        exportData() {
            this.loadExport = true;
            let params = {
                ...this.filters,
                startDate: this.filters.signDate ? this.filters.signDate[0] : '',
                endDate: this.filters.signDate ? this.filters.signDate[1] : ''
            }
            delete params.signDate
            downloadContractPayList(params).then(res => {
                // 处理blob
                if (res.data.type === "application/json") {
                    let blobReader = new Response(res.data).json();
                    blobReader.then((item) => {
                        this.$MessageBox.MessageWarning(item.msg);
                        this.loadExport = false;
                    });
                } else {
                    // 成功，预览/下载报告
                    this.$utils.download(res);
                    this.loadExport = false;
                }
            }).catch(() => {
                this.loadExport = false;
            })
        },
    }
}
</script>

<style lang="scss" scoped>
/deep/ .radius-dialog {
    background-image: url("~@/assets/image/statistics/dialog-bg.png");
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    border-radius: 12px;
    .el-dialog__body {
        padding: 15px 30px 30px 30px;
    }
    .el-dialog__header {
        padding-left: 30px;
        padding-right: 30px;
        .el-dialog__title {
            font-weight: 600;
        }
    }
    .dialog-title {
        h3 {
            display: inline-block;
            margin-right: 12px;
        }
        span {
            color: #7c7c7c;
            font-size: 14px;
        }
    }
}
.filters-container {
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    margin-bottom: 20px;
    border-radius: 10px;
    /deep/ .filter-line {
        display: flex;
        &:not(:last-of-type) {
            margin-bottom: 8px;
        }
        .title {
            min-width: 5rem;
            padding-top: 7px;
            color: $primary-font-color;
        }
        .title-name {
            min-width: 5rem;
            padding-top: 7px;
            color: $primary-font-color;
            white-space: nowrap;
        }
        .filter-ipt {
            width: 40%;
            border-radius: 1.6rem;
            box-shadow: 0 0.06667rem 0.4rem 0.06667rem rgba(0, 0, 0, 0.1);
            overflow: hidden;
            padding: 0 0.6rem;
            > .el-input {
                .el-input__inner {
                    height: 2.2rem;
                    line-height: 2.2rem;
                }
                .el-input__icon {
                    line-height: 2.2rem;
                }
            }
        }
        .filter-select {
            height: 2.2rem;
            .el-input__inner {
                height: 2.2rem;
                line-height: 2.2rem;
                border-radius: 1.6rem;
                border: none;
                box-shadow: 0 0.06667rem 0.4rem 0.06667rem rgba(0, 0, 0, 0.1);
                .el-range__icon {
                    line-height: 30px;
                }
                .el-range-input {
                    font-size: 15px;
                }
                .el-range-separator {
                    width: 20px;
                    line-height: 30px;
                }
            }
            .el-input__suffix {
                right: 0.5rem;
                .el-input__icon {
                    line-height: 2.2rem;
                }
            }
        }
    }
    .export-box {
        position: absolute;
        bottom: 0;
        right: 20px;
        > .el-button {
            border-radius: 0.8rem;
        }
    }
}
.red-text {
    max-width: calc(100% - 160px);
    color: #f53f3f;
    i {
        margin-right: 2px;
        font-size: 18px;
        font-weight: 600;
        vertical-align: -1px;
    }
    /deep/ .text b {
        margin: 0 2px;
    }
}
</style>